import { useNavigate } from 'react-router-dom'
import ROUTERS from './../../../commons/constans/router';
import { ReactComponent as IconFloat} from '../../../assets/images/icon_float.svg';
const voteAward = () => {
  const navigate = useNavigate();

  const gotToAwardVote = () => {
    navigate(ROUTERS.AWARD_VOTING)
  }
  return (
    <div className="vote-awards-fixed">
      <div className="vote-awards-fixed__content" onClick={gotToAwardVote}>
        <div className="vote-awards-fixed__content__text">
          <label className="awards">
            스포키즈 어워드
          </label>
          <label className="vote">
            투표하기
          </label>
        </div>
        <div className="vote-awards-fixed__content__icon">
          {/* <img src={IconFloat} alt="" /> */}
          <IconFloat />
        </div>
      </div>
    </div>
  )
}

export default voteAward
